module.exports = __webpack_public_path__ + "img/success-notification.b0708035.svg";